import { t } from "@lingui/macro"
import {
    Stack,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
    useTheme,
} from "@mui/material"
import { observer } from "mobx-react"
import { useCallback } from "react"

import { PropertiesStore } from "./store"

import { useStore } from "src/store/lib/useStore"
import { avy_api_pkg_segment_SegmentType } from "src/api"
import { useSegmentTypeTranslations } from "src/components/SegmentPicker/hooks/useSegmentTypeTranslations"

const segmentTypeOptions: avy_api_pkg_segment_SegmentType[] = [
    "propertyowner",
    "legalentity",
    "property",
    "building",
    "address",
    "propertyobject",
    "district",
    "area1",
    "area2",
    "area3",
]

export const SegmentTypeFilter = observer(() => {
    const store = useStore(PropertiesStore)
    const theme = useTheme()
    const translations = useSegmentTypeTranslations()

    const handleChange = useCallback(
        async (
            _: React.MouseEvent<HTMLElement>,
            value: avy_api_pkg_segment_SegmentType | null,
        ) => {
            if (value !== null) {
                await store.setSegmentType(value)
            }
        },
        [store],
    )

    return (
        <Stack spacing={0.5}>
            <Typography
                fontSize={14}
                fontWeight={400}
                color={theme.palette.grey[900]}
            >
                {t`properties.segment-type.label`}
            </Typography>
            <ToggleButtonGroup
                value={store.segmentType}
                onChange={handleChange}
                exclusive
                size="small"
                sx={{
                    "& .MuiToggleButton-root": {
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: "20px",
                        margin: "2px",
                        padding: "4px 12px",
                        fontSize: "0.875rem",
                        fontWeight: 400,
                        textTransform: "none",
                        color: theme.palette.text.secondary,
                        "&.Mui-selected": {
                            backgroundColor: theme.palette.grey[900],
                            color: theme.palette.common.white,
                            "&:hover": {
                                backgroundColor: theme.palette.grey[800],
                            },
                        },
                        "&:hover": {
                            backgroundColor: theme.palette.action.hover,
                        },
                    },
                }}
            >
                {segmentTypeOptions.map((type) => (
                    <ToggleButton key={type} value={type}>
                        {translations[type as keyof typeof translations]}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </Stack>
    )
})
